const convertToCSV = (data: Record<string, unknown>[]): string => {
  if (!data || data.length === 0) {
    return ""
  }

  const headerKeys = Object.keys(data[0])
  const header = headerKeys.join(",")
  const values = data
    .map((obj: Record<string, unknown>) =>
      headerKeys
        .map((key) => (obj[key] !== undefined && obj[key] !== null ? obj[key] : ""))
        .join(","),
    )
    .join("\n")

  return `${header}\n${values}`
}

export default convertToCSV
